import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Typography, Button } from "@mui/material";
import { useSelector } from "react-redux";

import { ThreeBounce } from "commons";

export function AdviserViewHeader({ handleClientSwitch, isStoppingImpersonation }) {
    const { isAdviser, username, primary } = useSelector(state => ({
        isAdviser: Boolean(state.user.adviserId),
        username: state.user.username,
        primary: state.theme.primary
    }));

    return isAdviser ? (
        <Container>
            <ResponsiveHeader variant="h3" color="secondary">
                {username} - read&#8209;only mode
            </ResponsiveHeader>
            <SwitchButton
                variant="contained"
                size="small"
                onClick={handleClientSwitch}
                disabled={isStoppingImpersonation}
            >
                {isStoppingImpersonation ? (
                    <Loading size={12} color={primary} data-testid="switch-client-loading" />
                ) : (
                    "Switch client"
                )}
            </SwitchButton>
        </Container>
    ) : null;
}

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    @media (min-width: ${props => props.theme.minWidth}) {
        height: ${props => props.theme.topBarHeightDesktop};
    }

    @media (max-width: ${props => props.theme.maxWidth}) {
        padding: 0 1em 0 1em;
        height: ${props => props.theme.topBarHeightMobile};
        order: 1;
    }
`;

const ResponsiveHeader = styled(Typography)`
    @media (max-width: ${props => props.theme.maxWidth}) {
        && {
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 65%;
            font-size: 1rem;
        }
    }
`;

const SwitchButton = styled(Button)`
    && {
        min-width: 110px;
        margin-left: 1rem;
    }
`;

const Loading = styled(ThreeBounce)`
    color: white;
`;

AdviserViewHeader.propTypes = {
    handleClientSwitch: PropTypes.func,
    isStoppingImpersonation: PropTypes.bool
};
